import React from 'react';
import { useSelector } from 'react-redux';
import { CCard, CCardBody, CRow, CCol, CButton } from 'compat/coreui';
import { IMAGE_URL } from '../../../Constants/constants';

// Your shop's public page IS the storefront — this screen links straight to it
// and reminds you what shoppers see there.
export default function PublicProfile() {
  const user = useSelector(state => state.user);
  const shopUrl = user && user._id ? `/businessnew/${user._id}` : '/';

  return (
    <CRow>
      <CCol xl={8} className="m-auto">
        <CCard>
          <CCardBody className="text-center" style={{ padding: '46px 30px' }}>
            <div className="bp-shop-avatar" style={{ margin: '0 auto 18px' }}>
              <img alt="" src={user && user.image ? IMAGE_URL + user.image : '/images/placeholder.svg'} />
            </div>
            <h3 style={{ fontWeight: 800 }}>{(user && user.businessName) || 'Your shop'}</h3>
            <p className="text-muted" style={{ maxWidth: 460, margin: '10px auto 24px' }}>
              This is exactly what shoppers see — your cover, products, deals, reviews,
              and photos, live on the marketplace.
            </p>
            <CButton color="success" className="text-white" style={{ padding: '12px 30px' }}
              onClick={() => window.open(shopUrl, '_blank')}>
              Open Your Live Storefront ↗
            </CButton>
            <p className="text-muted" style={{ fontSize: 12.5, marginTop: 22 }}>
              Improve it from here: add a cover photo in <strong>Photos</strong>, keep your
              catalog fresh in <strong>Products</strong>, and post offers in <strong>Deals</strong>.
            </p>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  );
}
